const formErrors = {
  status: '',
  message: null,
  errors: [],
  fieldErrors: {}
};

const invoiceMetadata: Accelerate.InvoiceMetadataState = {
  // billing area options are currently unused, but it is anticipated that they
  // will be used in the future.  pbc 9/8/2022.
  billingAreaOptions: [],
  billingProviderSearchResults: [],
  referringProviderSearchResults: [],
  performingProviderSearchResults: [],
  organization: null,
  processInstance: null,
  displayMode: null,
  invoice: null,
  formErrors: formErrors,
  providerRoleTypeConfig: [],
  useProviderDirectoryLocations: {
    on: false
  },
  invoiceOptions: {
    invoices: [],
    required_fields: [],
    summary: {
      departments: {},
      fee_schedules: {},
      all_departments: [],
      existing_departments: []
    }
  }
};

export { invoiceMetadata };
